



























import { Component, Vue, Watch } from 'vue-property-decorator';

import NavBar from '@/components/Sixth/NavBar.vue';
import StickyNavBar from '@/components/Sixth/StickyNavBar.vue';
import FooterComponent from '@/components/Sixth/FooterComponent.vue';

@Component({
  components: {
    FooterComponent,
    NavBar,
    StickyNavBar
  }
})
export default class SixthLayout extends Vue {
  private showSticky = false;
  private isHome = true;
  private isAbout = false;
  private windowSize = {
    height: 0,
    width: 0
  };

  @Watch('$route.name')
  private watchRouteName(name: string) {
    if (name === 'root_about') {
      this.isAbout = true;
      this.isHome = false;
    } else if (name === 'root') {
      this.isHome = true;
      this.isAbout = false;
    }
  }

  private get isDesktop() {
    return this.windowSize.width > 600;
  }

  private get isMobile() {
    return this.windowSize.width < 600;
  }

  private mounted() {
    this.windowSize.height = window.innerHeight;
    this.windowSize.width = window.innerWidth;
  }

  private created() {
    window.addEventListener('resize', this.handleResize);
    if (window.innerWidth >= 600) {
      window.addEventListener('scroll', this.handleScroll);
    }
  }

  private destroyed() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll);
  }

  private handleScroll(e: UIEvent) {
    this.showSticky = window.scrollY > window.innerHeight;
  }

  private handleResize(e: UIEvent) {
    this.windowSize.height = window.innerHeight;
    this.windowSize.width = window.innerWidth;
  }
}
